import { Box, styled } from "@mui/material";

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() =>
  createStyles({
    statusBadge: {
      background: "#FEE4E2 !important",
      border: "1px solid #E0E2E7",
      padding: "3px 10px",
      borderRadius: 20,
      height: 32,
      fontWeight: 600,
      fontSize: 10,
      lineHeight: "20px",
      color: "#F97066 !important",
    },
    statusBadgeActive: {
      background: "#D1FADF !important",
      border: "1px solid #D1FADF",
      color: "#32D583 !important",
    },
  })
);

export const Content = styled(Box)(() => ({
  width: "100%",
  fontFamily: "Manrope !important",
  flex: 1,
  flexDirection: "column",
  paddingBottom: "15px",
  alignItems: "center",
  justifyContent: "center",
}));

export default useStyles;
